export default [

     {
          path: '/asset-environment-category',
          name: 'AssetEnvironmentCategory',
          component: () => import("@/views/Page/AssetEnvironmentCategory/AssetEnvironmentCategory.vue"),
           meta: {
               title: 'Asset Environment Category',
          },
     }
];